import React from 'react';
import { useGlobalContext } from 'store/GlobalProvider';
import { graphql } from 'gatsby';
import { CarouselPushMobile } from 'components/CarouselPushMobile';
import { CarouselPushDesktop } from 'components/CarouselPushDesktop';

export const CarouselPush = (props) => {
  const { isMobile } = useGlobalContext();

  return isMobile ? <CarouselPushMobile {...props} /> : <CarouselPushDesktop {...props} />;
};

export const query = graphql`
  fragment SliceCarouselPushHome on PrismicHomeDataBodyCarouselPush {
    id
    slice_type
    primary {
      background
      label {
        text
      }
    }
    items {
      item_title {
        text
      }
      text {
        richText
      }
      link {
        url
        target
      }
      image {
        url
        alt
        dimensions {
          width
          height
        }
        thumbnails {
          mobile {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
      }
    }
  }

  fragment SliceCarouselPushPage on PrismicPageDataBodyCarouselPush {
    id
    slice_type
    primary {
      background
      label {
        text
      }
    }
    items {
      item_title {
        text
      }
      text {
        richText
      }
      link {
        url
        target
      }
      image {
        url
        alt
        dimensions {
          width
          height
        }
        thumbnails {
          mobile {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
      }
    }
  }
`;
